import React from "react";
import { Routes, Route } from "react-router-dom"
import MainPage from './Components/MainPage'
import Error from './Components/Error'
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Processing from "./Processing";



const App = () => {
  return (
    <>
      <Processing />
      <Header />
      <Routes>
        <Route exact path="/" element={<MainPage />} />
        <Route path="*" element={<Error />} />
      </Routes>
      <Footer />
    </>
  )
}

export default App;